import axios from "axios";
import {
  hasJwtInSessionStorage,
  terminateSessionAndGoToLogin,
} from "../Auth/sessionTermination";

/**
 * Requisições com axios "global" (não apiClient): em 401/403 com JWT no storage,
 * limpa sessão e envia ao login (apiClient tem interceptor próprio com refresh em 401).
 */
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (
      (status === 401 || status === 403) &&
      hasJwtInSessionStorage()
    ) {
      terminateSessionAndGoToLogin();
    }
    return Promise.reject(error);
  }
);
